import React, {useState} from "react";
import {inputDefaultDesign} from "../inputClass";
import {ContanctDetailPopUp} from "../component/ContanctDetailPopUp";


export function Ask() {
    const tableHeaders = [
        {label: "번호", key: "id"},
        {label: "상담일", key: "inquiryDate"},
        {label: "문의 분류", key: "category"},
        {label: "제목", key: "title"},
        {label: "내용", key: "content"},
        {label: "문의 상태", key: "status"}
    ];
    
    const inquiryList = [
        {
            id: 1,
            inquiryDate: "25.01.01",
            category: "결제 관련",
            title: "제목이 표시되는 영역",
            content: "내용이 표시되는 영역입니다............",
            status: "문의 요청"
        },
        {
            id: 2,
            inquiryDate: "24.12.31",
            category: "사이트 사용 관련",
            title: "제목이 표시되는 영역",
            content: "내용이 표시되는 영역입니다............",
            status: "답변 중"
        },
        {
            id: 3,
            inquiryDate: "24.12.30",
            category: "전문가 관련",
            title: "제목이 표시되는 영역",
            content: "내용이 표시되는 영역입니다............",
            status: "답변 완료"
        }
    ];
    
    const [popup, setPopup] = useState(false)
    
    return <section className={`p-8 w-[90%] flex-col gap-3 text-black`}>
        <div className={`w-full`}>
            <h1 className={`font-bold text-2xl mb-3`}>1:1 문의</h1>
            <div className={`flex gap-3`}>
                <div className={`w-[30%]`}>
                    <select className={inputDefaultDesign}>
                        <option value="">문의분류</option>
                        <option value="">문의타입</option>
                    </select>
                </div>
                <div className={`w-[70%]`}>
                    <input type="text" className={inputDefaultDesign}/>
                </div>
            </div>
            <div className={`my-3`}>
                <textarea name="" id="" cols="30" rows="10" className={`h-[300px] ${inputDefaultDesign}`}></textarea>
            </div>
            <div className={`flex gap-3`}>
                <div className={`py-4 px-5 bg-gray-50 text-gray-700 flex justify-between flex-grow rounded-lg`}>
                    <div>name.jpg</div>
                    <div>삭제</div>
                </div>
                <button className={`py-4 px-5 bg-white font-bold border-2 rounded-lg`}>+파일 첨부</button>
            </div>
        </div>
        <div className={`my-5`}>
            <h1 className={`font-bold text-2xl mb-2`}>검색 조건</h1>
            <div className={`flex justify-around  [&_*]:py-1 items-center gap-2`}>
                    <input type="date" id="date" name="date" className={`text-gray-600 border px-2`}/>-
                    <input type="date" id="date"
                           name="date"
                           className={`text-gray-600 border px-2`}/>
                    <input type="text" placeholder={"텍스트 입력"}
                            className={`px-4 text-gray-600  border-2 `}/>
                    <select name="" id="" className={`px-4 text-gray-600  border-2`}>
                        <option value="">문의 상태</option>
                    </select>
                    <button className={`bg-black  text-white px-4  `}>검색</button>
            </div>
        </div>
        <div>
            <h1 className={`font-bold text-2xl mb-2`}>문의 내역</h1>
            <table className="w-full border-collapse">
                <thead className={``}>
                <tr>
                    {tableHeaders.map((header) => (
                        <th key={header.key} className="px-4 py-5 ">
                            {header.label}
                        </th>
                    ))}
                </tr>
                </thead>
                <tbody>
                {inquiryList.map((inquiry) => (
                    <tr key={inquiry.id} onClick={()=>{
                        setPopup(true)
                    }}>
                        {tableHeaders.map((header) => (
                            <td key={header.key} className="border-none  px-4 py-4">
                                {inquiry[header.key] || "없음"}
                            </td>
                        ))}
                    </tr>
                ))}
                </tbody>
            </table>
        </div>
        {popup && <ContanctDetailPopUp fn={()=>{setPopup(false)}}/> }
        
    </section>
}

